import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import FacebookLogin from 'react-facebook-login';
import {actionFbLogin} from "../redux/actions";
import {useHistory} from "react-router";


const LoginFacebook = () => {
    const dispatch = useDispatch();
    let isLoggedIn = useSelector((state) => state.isLoggedIn)
    const history = useHistory();
    const responseFacebook = (response) => {
        if (response.accessToken) {
            dispatch(actionFbLogin(response))
        }
    }

    useEffect(() => {
        //console.log('isLoggedin', isLoggedIn)
        if (isLoggedIn) {
            const tm = setTimeout.nextTick(() => {
                history.push('/')
                clearTimeout(tm)
            }, 0)
        }
    })

    return <div>
        <FacebookLogin
            appId="307837795991061"
            autoLoad={true}
            fields="name,email,picture"
            scope="public_profile"
            callback={responseFacebook}
            icon="fa-facebook" />
    </div>
}

export default LoginFacebook;
